export const fetchAndConvertWebPtoJpegBase64 = async (url) => {
  try {
    const response = await fetch(url);
    const blob = await response.blob();

    const imageBitmap = await createImageBitmap(blob);

    const canvas = document.createElement("canvas");
    canvas.width = imageBitmap.width;
    canvas.height = imageBitmap.height;

    const ctx = canvas.getContext("2d");
    ctx.drawImage(imageBitmap, 0, 0);

    const jpegBase64 = canvas.toDataURL("image/jpeg", 0.92);
    return jpegBase64;
  } catch (e) {
    console.error("Failed to convert WebP to JPEG:", e);
    return null;
  }
};


export const convertAllImagesToBase64 = async (comparables) => {
  const convertImages = async (list) => {
    for (const item of list) {
      if (item.image && item.image.includes('corelogic')) {
        try {
          item.image = await fetchAndConvertWebPtoJpegBase64(item.image);
        } catch (e) {
          console.error(`Failed to convert image for ID: ${item.id}`, e);
        }
      }
    }
  };

  await convertImages(comparables.off);
  await convertImages(comparables.on);

  return comparables;
};